import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { zoomLevelInRange } from "../../../utils/validation.js";
import { createAction } from "../../../r-html/dist/store/index.js";
import { ActionType } from "./actions.js";
import { CenterStep } from "./state.js";
import { clearSortChannel } from "../../../utils/draw-relationship/index.js";
import { createSceneView, getActiveView, isSameCenters, toSteppedCenters } from "./view.js";
import { round } from "es-toolkit/compat";
//#region src/engine/modules/editor/view.actions.ts
function clearViewGeometry({ collections }, kind) {
	clearSortChannel(query(collections).collection("relationshipEntities").selectAll(), kind);
}
var getAimedView = (state, kind) => kind ? state.editor.views[kind] : getActiveView(state);
function clearViews(editor) {
	editor.views.flow = null;
}
var viewOpenAction = createAction(ActionType.viewOpen);
var viewOpen = (state, { payload: { kind, centerIds } }) => {
	clearViewGeometry(state, kind);
	state.editor.views[kind] = createSceneView(kind, centerIds);
};
var viewCloseAction = createAction(ActionType.viewClose);
var viewClose = (state, { payload: { kind } }) => {
	clearViewGeometry(state, kind);
	state.editor.views[kind] = null;
};
var viewScrollToAction = createAction(ActionType.viewScrollTo);
var viewScrollTo = (state, { payload: { originX, originY, kind } }) => {
	const view = getAimedView(state, kind);
	if (!view) return;
	view.originX = round(originX, 4);
	view.originY = round(originY, 4);
};
var viewStreamScrollToAction = createAction(ActionType.viewStreamScrollTo);
var viewStreamScrollTo = (state, { payload: { movementX, movementY, kind } }) => {
	const view = getAimedView(state, kind);
	if (!view) return;
	view.originX = round(view.originX + movementX, 4);
	view.originY = round(view.originY + movementY, 4);
};
var viewChangeZoomLevelAction = createAction(ActionType.viewChangeZoomLevel);
var viewChangeZoomLevel = (state, { payload: { value, kind } }) => {
	const view = getAimedView(state, kind);
	if (!view) return;
	view.zoomLevel = zoomLevelInRange(value);
};
var viewStreamZoomLevelAction = createAction(ActionType.viewStreamZoomLevel);
var viewStreamZoomLevel = (state, { payload: { value, kind } }) => {
	const view = getAimedView(state, kind);
	if (!view) return;
	view.zoomLevel = zoomLevelInRange(view.zoomLevel + value);
};
var viewMoveTableAction = createAction(ActionType.viewMoveTable);
var viewMoveTable = (state, { payload: { ids, movementX, movementY, kind } }) => {
	const view = getAimedView(state, kind);
	if (!view) return;
	for (const id of ids) {
		const point = view.positions[id];
		if (!point) continue;
		point.x = round(point.x + movementX, 4);
		point.y = round(point.y + movementY, 4);
	}
};
var viewSetLayoutAction = createAction(ActionType.viewSetLayout);
var viewSetLayout = ({ editor }, { payload: { kind, positions } }) => {
	const view = editor.views[kind];
	if (!view) return;
	view.positions = Object.fromEntries(Object.entries(positions).map(([id, { x, y }]) => [id, {
		x,
		y
	}]));
};
var viewChangeShowModeAction = createAction(ActionType.viewChangeShowMode);
var viewChangeShowMode = (state, { payload: { value, kind } }) => {
	const view = getAimedView(state, kind);
	if (!view) return;
	view.showMode = value;
};
var viewSetCentersAction = createAction(ActionType.viewSetCenters);
var viewSetCenters = (state, { payload: { tableIds, kind } }) => {
	const view = getAimedView(state, kind);
	if (!view || isSameCenters(view.centerIds, tableIds)) return;
	view.previousCenterIds = [...view.previousCenterIds, view.centerIds].slice(-100).map((ids) => [...ids]);
	view.nextCenterIds = [];
	view.centerIds = [...tableIds];
};
var viewStepCentersAction = createAction(ActionType.viewStepCenters);
var viewStepCenters = (state, { payload: { step, kind } }) => {
	const view = getAimedView(state, kind);
	if (!view) return;
	const [from, to] = step === CenterStep.previous ? [view.previousCenterIds, view.nextCenterIds] : [view.nextCenterIds, view.previousCenterIds];
	const tableIds = new Set(state.doc.tableIds);
	for (let ids = from.pop(); ids; ids = from.pop()) {
		const centerIds = toSteppedCenters(tableIds, view, ids);
		if (!centerIds) continue;
		to.push([...view.centerIds]);
		view.centerIds = centerIds;
		return;
	}
};
var changeVisualizationModeAction = createAction(ActionType.changeVisualizationMode);
var changeVisualizationMode = ({ editor }, { payload: { value } }) => {
	editor.visualizationMode = value;
};
var viewReducers = {
	[ActionType.viewOpen]: viewOpen,
	[ActionType.viewClose]: viewClose,
	[ActionType.viewScrollTo]: viewScrollTo,
	[ActionType.viewStreamScrollTo]: viewStreamScrollTo,
	[ActionType.viewChangeZoomLevel]: viewChangeZoomLevel,
	[ActionType.viewStreamZoomLevel]: viewStreamZoomLevel,
	[ActionType.viewMoveTable]: viewMoveTable,
	[ActionType.viewSetLayout]: viewSetLayout,
	[ActionType.viewChangeShowMode]: viewChangeShowMode,
	[ActionType.viewSetCenters]: viewSetCenters,
	[ActionType.viewStepCenters]: viewStepCenters,
	[ActionType.changeVisualizationMode]: changeVisualizationMode
};
var viewActions = {
	viewOpenAction,
	viewCloseAction,
	viewScrollToAction,
	viewStreamScrollToAction,
	viewChangeZoomLevelAction,
	viewStreamZoomLevelAction,
	viewMoveTableAction,
	viewSetLayoutAction,
	viewChangeShowModeAction,
	viewSetCentersAction,
	viewStepCentersAction,
	changeVisualizationModeAction
};
//#endregion
export { changeVisualizationModeAction, clearViews, viewActions, viewChangeShowModeAction, viewChangeZoomLevelAction, viewCloseAction, viewMoveTableAction, viewOpenAction, viewReducers, viewScrollToAction, viewSetCentersAction, viewSetLayoutAction, viewStepCentersAction, viewStreamScrollToAction, viewStreamZoomLevelAction };
